import { SxStyleProp } from "theme-ui"

export const trigger: SxStyleProp = {
  display: "inline-flex",
  appearance: "none",
  border: 0,
  backgroundColor: "transparent",
  padding: 0,
  "&:focus": {
    outline: "2px solid red",
    outlineColor: "outline",
  },
}

export const box: SxStyleProp = {
  position: "relative",
  variant: "tooltip.default",
  outline: 0,
  transitionProperty: "transform, visibility, opacity",

  ".tippy-content": {
    position: "relative",
    zIndex: 1,
  },

  ".tippy-arrow": {
    width: 4,
    height: 4,
    variant: "tooltip.default.arrow",
  },

  '&[data-placement^="top"] > .tippy-arrow': {
    bottom: "-8px",
  },

  '&[data-placement^="bottom"] > .tippy-arrow': {
    top: "-8px",
  },

  '&[data-placement^="left"] > .tippy-arrow': {
    right: "-8px",
  },

  '&[data-placement^="right"] > .tippy-arrow': {
    left: "-8px",
  },

  ".tippy-arrow::before": {
    content: '""',
    position: "absolute",
    borderColor: "transparent",
    borderStyle: "solid",
  },

  '&[data-placement^="bottom"] > .tippy-arrow::before': {
    top: 0,
    left: 0,
    borderWidth: "0 8px 8px",
    borderBottomColor: "initial",
    transformOrigin: "center bottom",
  },

  '&[data-placement^="top"] > .tippy-arrow::before': {
    bottom: 0,
    left: 0,
    borderWidth: "8px 8px 0",
    borderTopColor: "initial",
    transformOrigin: "center top",
  },

  '&[data-placement^="right"] > .tippy-arrow::before': {
    left: 0,
    borderWidth: "8px 8px 8px 0",
    borderRightColor: "initial",
    transformOrigin: "center right",
  },

  '&[data-placement^="left"] > .tippy-arrow::before': {
    borderWidth: "8px 0 8px 8px",
    borderLeftColor: "initial",
    right: 0,
    transformOrigin: "center left",
  },

  '&[data-placement="top"] > .tippy-arrow::before': {
    left: '-6px',
  },
}
